export const enum PropertySavedIdbStatechartActionEnum {
  updateDb = 'updateDb',
  updateLocalCache = 'updateLocalCache',
  cancelUpdate = 'cancelUpdate',
  loadAll = 'loadAll',
  deleteAll = 'deleteAll',
  firstLoading = 'firstLoading',
}
